import { render } from "./ModalDefaultButtons.vue?vue&type=template&id=b4f74566"
import script from "./ModalDefaultButtons.vue?vue&type=script&lang=js"
export * from "./ModalDefaultButtons.vue?vue&type=script&lang=js"
script.render = render

export default script